import { defineComponent, computed } from "vue";
import AutoTips from "@/components/AutoTips/index.vue";
export default defineComponent({
    props: {
        config: {
            type: Object,
            required: true
        },
        model: {
            type: Object,
            required: true
        }
    },
    components: {
        AutoTips: AutoTips
    },
    setup: function setup(props, param) {
        var emit = param.emit;
        var checked = computed({
            get: function() {
                return props.model[props.config.prop];
            },
            set: function(val) {
                emit("update-field", {
                    prop: props.config.prop,
                    value: val
                });
            }
        });
        return {
            checked: checked
        };
    }
});
